module.exports = __webpack_public_path__ + "static/img/9.ad4f5fd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/6/zh/9.png
// module id = g67B
// module chunks = 0